import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser, FieldValueConverters } from './FieldValueConverters'
import { BooleanFormatter } from './Formatters/BooleanFormatter'

export class CheckBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    readonlyTrueValue: pt.any,
    readonlyFalseValue: pt.any,
    readonlyStatic: pt.any
  })

  static defaultProps = {
    readonlyTrueValue: 'Yes',
    readonlyFalseValue: 'No'
  }

  render () {
    const { readonlyTrueValue, readonlyFalseValue, checkLabel = '', readonlyStatic, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest} isFieldSet={true}>
        {({ testId, showError, value, onChange, name, placeHolder, loading, readonly, label }) => {
          if (readonly) {
            var formattedValue = BooleanFormatter({ trueValue: readonlyTrueValue, falseValue: readonlyFalseValue, value: value })
            return <input data-tid={testId} type='text' readOnly name={`view${name}`} id={`view${name}`} value={formattedValue} />
          } else if (readonlyStatic) {
            return <>
            <input data-tid={testId} disabled id={`check${name}disabled`} name={`check${name}`} invalid={showError} checked={value} type="checkbox" />
            <label htmlFor={`check${name}diabled`}>{checkLabel}</label>
          </>
          } else {
            return <>
              <input data-tid={testId} disabled={loading} id={`check${name}`} name={`check${name}`} invalid={showError} onChange={onChange} checked={value} type="checkbox" />
              <label htmlFor={`check${name}`}>{checkLabel}</label>
            </>
          }
        }}
      </FieldLayoutBox>
    )
  }
};

export const CheckBox = ({ parse, format, fieldType = FieldValueConverters.Boolean, name, namePrefix, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={CheckBoxClass} /> } // eslint-disable-line
export default CheckBox
